<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="deliveryInformation_tooltip_NAME"  :name="deliveryInformation_tooltip_NAME" :description="deliveryInformation_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row justify-content-center">
      <div class="col-sm-6" style="padding-top: 20px;">
         <label for="deliverToPlace">Deliver to Place</label>
          <base-input
            :disabled="isReadOnly || isPartnerAccount"
            data-vv-as="Deliver to Place"
            v-model="deliveryInfo.deliveryPlace"
            name="deliverToPlace"
            v-validate="'required|max:500'"
            :error="getError('deliverToPlace')"
          >
          </base-input>
      </div>
      <div class="col-sm-6" style="padding-top: 20px;">
        <label>Deliver to Country (Location)</label>
        <v-select
          :disabled="isReadOnly || isPartnerAccount"
          v-model="deliveryInfo.deliveryCountryId"
          :reduce="(country) => country.countryId"
          label="name"
          :options="allCountries"
          placeholder="Select an option"
          data-vv-as="Delivery to Country (Location)"
          name="deliveryCountryId"
           :class="errors.has('deliveryCountryId') ? 'has-danger' : ''"
          v-validate="'required'"
          :error="getError('deliveryCountryId')"
        ></v-select>
          <span v-show="errors.has('deliveryCountryId')" class="error"
          >Deliver to Country (Location) is required
         </span>
      </div>
      <div class="col-sm-12" style="padding-top: 20px;">
        <label>Delivery Unit / Office</label>
        <base-input
          :disabled="isReadOnly || isPartnerAccount"
          data-vv-as="Delivery Unit / Office"
          v-model="deliveryInfo.deliveryUnit"
          name="unitOffice"
          v-validate="'required|max:300'"
          :error="getError('unitOffice')"
        >
        </base-input>
      </div>
      <div class="col-sm-12" style="padding-top: 20px;">
        
        <label>Delivery Time</label>
    <tool-tip  v-on:updateToolTip="updateToolTip($event)" v-if="delivery_tooltip_NAME"  :name="delivery_tooltip_NAME" :description="delivery_tooltip_DESCRIPTION" :editable="editable"></tool-tip>

      </div>
      <div class="col-sm-6">
        <label>Start Date</label>
        <el-date-picker
          :disabled="isReadOnly || isPartnerAccount"
          v-model="deliveryInfo.deliveryStartDate"
          type="date"
          :editable="false"
          placeholder="Start date"
          format="dd-MMMM-yyyy"
          name="startDate"
          data-vv-as="Start Date"
          :class="{'has-danger': errors.has('startDate')}"
          v-validate="`${!isLegacyOrder ? 'required' : ''}`"
          :picker-options="startDatePickerOptions"
        >
        </el-date-picker>
        <span v-show="errors.has('startDate')" class="error"
          >Start Date is required
         </span>
      </div>
      <div class="col-sm-6">
        <label>End Date</label>
        <el-date-picker
          :disabled="isReadOnly || isPartnerAccount"
          v-model="deliveryInfo.deliveryEndDate"
          type="date"
          :editable="false"
          placeholder="End date"
          format="dd-MMMM-yyyy"
          name="endDate"
          data-vv-as="End Date"
          :class="{'has-danger': errors.has('endDate')}"
          v-validate="`${!isLegacyOrder ? 'required' : ''}`"
          :picker-options="endDatePickerOptions"
        >
        </el-date-picker>
         <span v-show="errors.has('endDate')" class="error"
          >End Date is required
         </span>
      </div>
      <div v-show="isLegacyOrder" class="col-sm-12">
        <label>Delivery Time Legacy</label>
        <base-input
          v-model="deliveryInfo.deliveryTimeLegacy"
          name="deliveryTimeLegacy"
          :disabled="true"
          placeholder="Legacy date"
        >
        </base-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-12" style="padding-top: 20px;">
        <div class="pull-right">
          <base-button
            type="primary"
            :disabled="isReadOnly || isPartnerAccount"
            wide
            @click.native="submit"
            class="btn-next"
            >Save</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Utility from "@/mixins/utility/utility";
import moment from "moment";
import Util from "@/util/util";
import  toolTip  from "../../Tooltip";


export default {
  props: ["isReadOnly"],
  name: "DeliveryInformation",
  mixins: [Utility],
  data() {
    return {
      startDatePickerOptions: {
        disabledDate: this.disabledStartDate,
      },
      endDatePickerOptions: {
        disabledDate: this.disabledEndDate,
      },
      delivery_tooltip_NAME : '',
      delivery_tooltip_DESCRIPTION: '',
      deliveryInformation_tooltip_NAME : '',
      deliveryInformation_tooltip_DESCRIPTION : '',
      
    };
  },
  async mounted() {
   
   await this.getAllTooltips()
   this.loadToolTips()
 
 },
  components: {
    toolTip
  },
  computed: {
    ...mapGetters({
      allCountries: "countries/allCountries",
      deliveryInfo: "deliveryInformation/deliveryInfo",
      deliveryInfoErrors: "deliveryInformation/deliveryInfoErrors",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
     isLegacyOrder() {
      return Util.isLegacyOrder(this.orderMetadata.createDate);
    },
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      loadDeliveryInformation: "deliveryInformation/loadDeliveryInformation",
      getDeliveryInformationStatus:
        "deliveryInformation/getDeliveryInformationStatus",
        getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const deliveryTimeInfo = this.toolTips.find(e => e.name === "DeliveryTime")
    const deliveryInformationVal = this.toolTips.find(e => e.name === "DeliveryInfoModule")
    if(deliveryTimeInfo.status){
      this.delivery_tooltip_DESCRIPTION = deliveryTimeInfo.description ? deliveryTimeInfo.description :  null
      this.delivery_tooltip_NAME = deliveryTimeInfo.name ? deliveryTimeInfo.name :  null
    }
    if(deliveryInformationVal.status){
    this.deliveryInformation_tooltip_DESCRIPTION = deliveryInformationVal.description ? deliveryInformationVal.description: null
      this.deliveryInformation_tooltip_NAME = deliveryInformationVal.name ? deliveryInformationVal.name: null
  }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    loaded() {
      this.getAllCountries();
      this.$validator.errors.clear();

      if(this.getOrderIdFromRoute !== 0) {
      this.loadDeliveryInformation(this.getOrderIdFromRoute);
      }
    },
    disabledStartDate(time) {
      let disabled = false;

      if (!this.isNullOrEmpty(this.deliveryInfo.deliveryEndDate)) {
        const selectedTime = new moment(time.getTime());

        const minStartDate = new moment(
          this.deliveryInfo.deliveryEndDate
        ).subtract(1, "year");
        const maxStartDate = new moment(this.deliveryInfo.deliveryEndDate);

        if (selectedTime < minStartDate) {
          disabled = true;
        }

        if (selectedTime > maxStartDate) {
          disabled = true;
        }
      }

      return disabled;
    },
    disabledEndDate(time) {
      let disabled = false;

      if (!this.isNullOrEmpty(this.deliveryInfo.deliveryStartDate)) {
        const selectedTime = new moment(time.getTime());

        const minEndDate = new moment(this.deliveryInfo.deliveryStartDate);
        const maxEndDate = new moment(this.deliveryInfo.deliveryStartDate).add(
          1,
          "year"
        );

        if (selectedTime < minEndDate) {
          disabled = true;
        }

        if (selectedTime > maxEndDate) {
          disabled = true;
        }
      }

      return disabled;
    },
    showDeliveryInfoErrors () {
      if(this.deliveryInfoErrors.length > 0 ) {
        this.deliveryInfoErrors.forEach(error => this.$toast.error(error))
      }
    },
    async submit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let ctx = this;
          this.$store
            .dispatch(
              "deliveryInformation/saveDeliveryInfoToServer",
              this.getOrderIdFromRoute
            )
            .then(() => {
              ctx.getDeliveryInformationStatus(ctx.getOrderIdFromRoute).then(() => {
                    ctx.showDeliveryInfoErrors();
                  });
              ctx.loadDeliveryInformation(this.getOrderIdFromRoute);
            })
            .catch((errorMessage) => {
             this.$toast.error(errorMessage);
            });
        } else {
         this.$toast.error("Please fill the required fields.");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    //validate() {
    //    return this.$validator.validateAll().then(res => {
    //        this.$emit('on-validated', res, this.model);
    //        return res;
    //    });
    //}
  },
};
</script>

<style></style>
